import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

export function useTenantAdminViewAllSRsEnabled() {
  const isEnabled = useFlag<boolean>(FeatureFlag.TenantAdminViewAllSRs, false);

  return Boolean(isEnabled);
}
